import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { auth } from "./firebaseConfig";

export const createUser = async (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
};

export const signInUser = async (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
};

export const sendEmail = () => {
    return sendEmailVerification(auth.currentUser)
      .then(() => {
        console.log("Verification email sent.");
      })
      .catch((error) => {
        console.error("Error sending verification email:", error.message);
      });
   
}


export const signOutUser = () => {
    return auth.signOut();
}